import { css } from 'styled-components';

const sizes = {
  uhd: 1980,
  widescreen: 1280,
  desktop: 1024,
  tablet: 768,
  mobile: 640,
};

export const media = Object.keys(sizes).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${sizes[label]}px) {
      ${css(...args)};
    }
  `;
  return acc;
}, {});
